import { render, staticRenderFns } from "./cpUploader.vue?vue&type=template&id=5099bf7c&scoped=true&"
import script from "./cpUploader.vue?vue&type=script&lang=js&"
export * from "./cpUploader.vue?vue&type=script&lang=js&"
import style0 from "./cpUploader.vue?vue&type=style&index=0&id=5099bf7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099bf7c",
  null
  
)

export default component.exports